import React from "react"
import { Table as AntTable } from "antd"
import { ExtraButtons } from "src/components/extra-buttons"
import { Header } from "src/components/layout/header"
import { TableSearch } from "src/components/table-search"
import { VisibilityProvider } from "src/components/visibility-provider"
import { usePermission, useUpdateHeaderTitle } from "src/hooks"
import { EditDrawer } from "src/pages-lib/promotion-categories/edit-drawer"
import {
  useGetCategories,
  useManageItems,
} from "src/pages-lib/promotion-categories/model"
import { getColumns } from "src/pages-lib/promotion-categories/table-columns"
import styled from "styled-components"

export default function PromotionCategories() {
  const { hasPermission } = usePermission()
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [editDrawerState, setEditDrawerState] = React.useState(false)

  // const [filterDrawerState, setFilterDrawerState] = useState(false)
  // const [sortableDrawerState, setSortableDrawerState] = useState(false)

  const {
    items: dataCategories,
    refetch: getItems,
    handleSearchTable,
    paginationParams,
  } = useGetCategories()

  const { editData, onSaveEdit, onCreate, onDelete, onEditItem } = useManageItems(
    dataCategories,
    getItems,
    onSuccessEdit
  )

  const headerTitle = useUpdateHeaderTitle({
    items: dataCategories,
    defaultTitle: "0 Категорий",
    arrType: ["Категория", "Категории", "Категорий"],
  })

  function onSuccessEdit() {
    setEditDrawerState(!editDrawerState)
  }

  const columns = getColumns(hasPermission("promotion-categories.edit") ? onEditItem : null, hasPermission("promotion-categories.delete") ? onDelete : null)

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            onCreate={hasPermission("promotion-categories.create") ? () => setCreateDrawerState(true) : undefined}
            // onFilter={() => setFilterDrawerState(!filterDrawerState)}
            // onSort={() => setSortableDrawerState(!sortableDrawerState)}
            titles={{ onCreate: "Добавить Категорию" }}
          />
        }
      />
      <TableSearch handleSearch={handleSearchTable} placeholder={"Поиск по ID или названию"} />
      <StyledTable
        dataSource={dataCategories}
        columns={columns}
        pagination={paginationParams.pagination}
      />
      {hasPermission("promotion-categories.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <EditDrawer
            onSave={onCreate}
            onClose={() => setCreateDrawerState(false)}
            title={"Создание категории"}
          />
        </VisibilityProvider>
      )}

      {hasPermission("promotion-categories.edit") && (
        <VisibilityProvider visible={editDrawerState}>
          <EditDrawer
            onSave={onSaveEdit}
            onClose={() => setEditDrawerState(false)}
            initialValues={editData}
            title={"Редактирование категории"}
          />
        </VisibilityProvider>
      )}
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
